import AbstractElement from '../AbstractElement';

export default class CRowElement extends AbstractElement{
    constructor(data,axisX,axisY,width,config,inputManager){
        super();
        this._label = data['label'];
        this._contains = data['contains'];
        this._all = data['all'];
        this._items = data['items'];
        this._axisX = axisX;
        this._axisY = axisY;
        this._width=width;
        this._config=config;
        this._inputManager=inputManager;
        this._data=data;
    }

    update(context, labelWidth){
        let me=this;
        let axisX=this._axisX;
        let axisY=this._axisY;
        let size=0;
        context.beginPath();
        context.stroke();
        context.fillText(this._label,axisX,axisY+15);
        axisX+=labelWidth;
        size=30;

        let sum = 0;
        let scaleX = ((this._width-labelWidth)/100);
        this._items.forEach(function (item,index) {
            sum += item;
            size = me.drawItem(context, item, me._data, axisX, axisY, me._config['labels'][index]['color'], me._data['group'][index], scaleX);
            axisX += size;
        });
        context.stroke();
    }

    drawItem(context, item, data, axisX, axisY, color, node, scaleX) {
        let text = Math.round(item*100)/100+'%';
        let measureText=context.measureText(text);
        let widthText=measureText.width;
        let heightText=5;

        let size = scaleX * item;
        let height=20;
        context.fillStyle = color;
        context.fillRect(axisX,axisY,size,height);//calc size
        context.fillStyle='#000000';

        if(widthText<=size){
            context.fillText(text,axisX+((size/2-widthText/2)),axisY+((height+heightText)/2));
        }

        this._inputManager.addEventClick(axisX, axisY, axisX + size, axisY + height, this._clickCallback(data, node));
        this._inputManager.addEventMouseOver(axisX, axisY, axisX + size, axisY + height, this._mouseOnCallback(data, node), this._mouseOutCallback(data, node));

        return size;
    }

    _clickCallback(data,node) {
        let me=this;
        return function () {
            me._config['callback'](data,node);
        }
    }

    _mouseOnCallback(data,node) {
        let me=this;
        return function () {
            document.body.style.cursor='pointer';
        }
    }

    _mouseOutCallback(data,node) {
        let me=this;
        return function () {
            document.body.style.cursor='auto';
        }
    }

    getLabel() {
        return this._label;
    }
}


// WEBPACK FOOTER //
// ./src/components/cchart/Template/CRowElement.js